import { RealMeetup, BookingDetails } from '../types';
import { getGoogleMapsNavigationUrl } from '../lib/locationService';

const STORAGE_KEY = 'pairup_real_meetups';

export const getRealMeetups = (): RealMeetup[] => {
  try {
    // Ensure old fake companion jobs from prior demo are always purged
    localStorage.removeItem('pairup_active_companion_jobs');
    
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (Array.isArray(parsed)) {
      // Filter out any hardcoded demo IDs just in case
      return parsed.filter(
        (m: any) =>
          m.id !== 'JOB-901' &&
          m.id !== 'JOB-902' &&
          m.id !== 'JOB-903' &&
          m.clientName !== 'Sneha Sengupta' &&
          m.clientName !== 'Kabir Sengupta' &&
          m.clientName !== 'Tanya Roy'
      );
    }
  } catch (e) {
    console.error(e);
  }
  return [];
};

export const saveRealMeetup = (booking: BookingDetails, otpCode: string): RealMeetup => {
  const current = getRealMeetups();
  const mapsUrl = booking.meeting_location_details
    ? getGoogleMapsNavigationUrl(booking.meeting_location_details)
    : `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(booking.meetingLocation)}`;

  const newMeetup: RealMeetup = {
    id: `MEET-${Date.now()}`,
    bookingId: `BK-${Math.floor(100000 + Math.random() * 900000)}`,
    title: `${booking.occasion} with ${booking.companion.name}`,
    companionName: booking.companion.name,
    companionImage: booking.companion.image,
    clientName: 'Verified Client',
    location: booking.meetingLocation,
    city: booking.city,
    meeting_location_details: booking.meeting_location_details,
    google_maps_url: mapsUrl,
    date: booking.date,
    time: booking.time,
    hours: booking.durationHours,
    ratePerHour: booking.companion.hourlyRate,
    totalAmount: booking.totalAmount,
    expectedOtp: otpCode,
    serviceCategory: booking.occasion,
    status: 'pending',
    createdAt: Date.now()
  };

  const updated = [newMeetup, ...current];
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
    localStorage.removeItem('pairup_active_companion_jobs');
  } catch (e) {
    console.error(e);
  }
  return newMeetup;
};

export const completeRealMeetup = (idOrOtp: string): RealMeetup | null => {
  const current = getRealMeetups();
  let completedItem: RealMeetup | null = null;

  const updated = current.map((m) => {
    if ((m.id === idOrOtp || m.expectedOtp === idOrOtp) && m.status === 'pending') {
      completedItem = {
        ...m,
        status: 'completed' as const,
        completedAt: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
      };
      return completedItem;
    }
    return m;
  });

  if (completedItem) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
    } catch (e) {
      console.error(e);
    }
  }
  return completedItem;
};
